(function () {
  const INTERVAL_MS = 2500;
  const timers = new WeakMap();

  function setActiveItem(items, index) {
    items.forEach((item, i) => {
      const isActive = i === index;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  }

  function initContainer(container) {
    if (container.dataset.flippingTextReady === 'true') return;

    const items = Array.from(container.querySelectorAll('.flipping-text-item'));
    if (items.length <= 1) return;

    container.dataset.flippingTextReady = 'true';

    let activeIndex = items.findIndex((item) => item.classList.contains('is-active'));
    if (activeIndex < 0) activeIndex = 0;

    setActiveItem(items, activeIndex);

    const timer = window.setInterval(() => {
      activeIndex = (activeIndex + 1) % items.length;
      setActiveItem(items, activeIndex);
    }, INTERVAL_MS);

    timers.set(container, timer);
  }

  function initAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.flipping-text').forEach(initContainer);
  }

  function boot() {
    initAll(document);

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
